import {
  Button,
  CardActionArea,
  Typography,
  useMediaQuery,
  useTheme,
} from "@material-ui/core"
import PropTypes from "prop-types"
import React from "react"
import { Link } from "react-router-dom"
import dragGray from "~/assets/Icons/noun_drag_3124730_gray.svg"
import PaperListRow from "~/components/Common/PaperListRow"

import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import Box from "../../Common/Box"
import useStyles from "./styles"

const CategoryCard = ({ category, view, viewFn, provided, index, locked }) => {
  const classes = useStyles()
  const theme = useTheme()
  const smScreen = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <div
      className="cursor-pointer mb-[16px]"
      ref={provided?.innerRef}
      {...provided?.draggableProps}
    >
      <CardActionArea to={`categories/${category.id}`} component={Link}>
        <PaperListRow
          className={classes.container}
          componentHeight={smScreen ? "96px" : "64px"}
        >
          <Box
            className={classes.infoContainer}
            width={!view || locked ? "95%" : "80%"}
          >
            {!smScreen && (
              <Box width="10%" className={classes.titleBox}>
                <Typography
                  variant="h3"
                  style={{ fontWeight: 600 }}
                  color="primary"
                >
                  {category.id}
                </Typography>
              </Box>
            )}
            {!smScreen && (
              <Box width="10%" className={classes.titleBox}>
                <Typography
                  variant="h3"
                  style={{ fontWeight: 600 }}
                  color="primary"
                >
                  {index + 1}
                </Typography>
              </Box>
            )}
            <Box width="30%" className={classes.nameText}>
              <Typography
                variant="h3"
                style={{ fontWeight: 600 }}
                color="primary"
              >
                {category.name}
              </Typography>
            </Box>
            <Box width="20%" className={classes.nameText}>
              <Typography
                variant="h3"
                style={{ fontWeight: 600 }}
                color="primary"
              >
                {category.type === "topic" ? "Topic" : "Partner"}
              </Typography>
            </Box>
            <Box width="15%" className={classes.nameText}>
              <Typography
                variant="h3"
                style={{ fontWeight: 600 }}
                color="primary"
                className="capitalize"
              >
                {category.type === "partner" ? category.partner_status : ""}
              </Typography>
            </Box>
            <Box width="15%" className={classes.nameText}>
              <Typography
                variant="h3"
                style={{ fontWeight: 600 }}
                color="primary"
                className="capitalize"
              >
                {category.published_state}
              </Typography>
            </Box>
          </Box>
          {view && !smScreen && (
            <Button color="secondary" onClick={viewFn}>
              View
            </Button>
          )}
          {!locked && !smScreen && (
            <PermissionsWrapper permissionGroup="admin">
              <div className={classes.dragHandle} {...provided.dragHandleProps}>
                <img src={dragGray} alt="" width="18px" />
              </div>
            </PermissionsWrapper>
          )}
        </PaperListRow>
      </CardActionArea>
    </div>
  )
}

CategoryCard.propTypes = {
  category: PropTypes.object,
  title: PropTypes.string,
  bio: PropTypes.string,
  view: PropTypes.bool,
  viewFn: PropTypes.func,
  provided: PropTypes.object,
  index: PropTypes.number,
  locked: PropTypes.bool,
}

export default CategoryCard
